import { render } from "./ProductDetail.vue?vue&type=template&id=5327ba58"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/linchiao-jo/Desktop/OnGoing/01-六角切版/07-Vue直播班_2022/Week8/website-01/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__